/**
 * Minimalist user/person icon: circular ring (head) + U-shaped shoulders.
 * Dark slate/blue style for professional dashboard use.
 */
export default function UserIcon({ size = 20, color = 'currentColor', style = {} }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: 'block', flexShrink: 0, ...style }}
    >
      {/* Head - circular ring */}
      <circle cx="12" cy="8" r="4" />
      {/* Shoulders - U-shaped arc */}
      <path d="M5 20 Q12 12 19 20" />
    </svg>
  );
}
